import { BaseIcon } from './BaseIcon';

const HelpOutlineIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.8649 17H12.8749M12.8649 14C13.7555 12.0938 15.8649 12.2344 15.8649 10C15.8649 8.5 14.8649 7 12.8649 7C11.317 7 10.3681 7.89844 10.0182 9M12.8649 21C17.8354 21 21.8649 16.9706 21.8649 12C21.8649 7.02944 17.8354 3 12.8649 3C7.89431 3 3.86487 7.02944 3.86487 12C3.86487 16.9706 7.89431 21 12.8649 21Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default HelpOutlineIcon;
